export const CategoriesType=[
    {
        id:0,
        name:"飯店",
        amount:"873,205",
        img:"https://cf.bstatic.com/xdata/images/xphoto/square300/57584488.webp?k=bf724e4e9b9b75480bbe7fc675460a089ba6414fe4693b83ea3fdd8e938832a6&o=",
    },
    {
        id:1,
        name:"公寓",
        amount:"886,889",
        img:"https://cf.bstatic.com/static/img/theme-index/carousel_320x240/card-image-apartments_300/9f60235dc09a3ac3f0a93adbc901c61ecd1ce72e.jpg",
    },
    {
        id:2,
        name:"度假村",
        amount:"17,907",
        img:"https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_resorts/6f87c6143fbd51a0bb5d15ca3b9cf84211ab0884.jpg",
    },
    {
        id:3,
        name:"Villa",
        amount:"465,344",
        img:"https://cf.bstatic.com/static/img/theme-index/carousel_320x240/card-image-villas_300/dd0d7f8202676306a661aa4f0cf1ffab31286211.jpg",
    },
    {
        id:4,
        name:"木屋",
        amount:"35,559",
        img:"https://cf.bstatic.com/static/img/theme-index/carousel_320x240/card-image-chalet_300/8ee014fcc493cb3334e25893a1dee8c6d36ed0ba.jpg",
    },
    {
        id:5,
        name:"小屋",
        amount:"152,731",
        img:"https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_cottages/5e1fd9cd716f4825c6c7eac5abe692c52cc64516.jpg",
    },
    {
        id:6,
        name:"豪華露營",
        amount:"13,052",
        img:"https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_glamping/6e181b9e942c160f4605239be7ddc1728cbcc4c8.jpg",
    },
    {
        id:7,
        name:"飯店式公寓",
        amount:"34,771",
        img:"https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_glamping/6e181b9e942c160f4605239be7ddc1728cbcc4c8.jpg",
    },
    {
        id:8,
        name:"度假屋",
        amount:"465,344",
        img:"https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_aparthotel/10e092f390b128dcff92727912299eef7824b751.jpg",
    },
    {
        id:9,
        name:"家庭旅館",
        amount:"106,771",
        img:"https://cf.bstatic.com/xdata/images/xphoto/square300/57584488.webp?k=bf724e4e9b9b75480bbe7fc675460a089ba6414fe4693b83ea3fdd8e938832a6&o=",
    },
    {
        id:10,
        name:"青年旅館",
        amount:"16,729",
        img:"https://cf.bstatic.com/xdata/images/xphoto/square300/57584488.webp?k=bf724e4e9b9b75480bbe7fc675460a089ba6414fe4693b83ea3fdd8e938832a6&o=",
    },

]

export const CategoriesCities=[
    {
        id:0,
        name:"台南",
        amount:"583 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/square250/687880.webp?k=a8f37ac28f438390034f6492e1ece731900df0f6133050a754123c969d7fc6d8&o=",
    },
    {
        id:1,
        name:"台中",
        amount:"502 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/square250/687892.webp?k=0f5cc456997c9fa5b99510dc453534730620c0867d94630639c74b4c18641c71&o=",
    },
    {
        id:2,
        name:"宜蘭縣",
        amount:"1030 間住宿",
        img:"https://cf.bstatic.com/xdata/images/region/square250/69956.webp?k=a79c8229fe2b508887961cafe02d79b9c45d42d7d06882f6d150af327e0adcdf&o=",
    },
    {
        id:3,
        name:"花蓮市",
        amount:"603 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/square250/687822.webp?k=4750fc80f938ae0b7c16d0ac306c30f949c9ad7baba7ab79cfb7940e991849b7&o=",
    },
    {
        id:4,
        name:"台東市",
        amount:"560 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/square250/687910.webp?k=ddda35cd7e422bfe96ee16fa84d4d63fe71e30fb738df85533c33c5a7365497f&o=",
    },
    {
        id:5,
        name:"台北",
        amount:"1433 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/square250/687919.webp?k=eccf1ef09bcc42899712d36fc3972d2c1973cb7fa1d961affd01d4f8e613ff23&o=",
    },
    {
        id:6,
        name:"高雄",
        amount:"481 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/square250/687840.webp?k=468bbe176fbf6b09c1b0778dd14437c614a66c44ecab77429683d39bbc089aa2&o=",
    },
    {
        id:7,
        name:"墾丁",
        amount:"113 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/square250/687844.webp?k=b067e641ffd5aa9e7272615eb5856658792d881a74845ea905b240deaedb9005&o=",
    },
    {
        id:8,
        name:"礁溪鄉",
        amount:"310 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/square250/687797.webp?k=9529bb8387606c401820857c303eaa2010c96fc7797a0fffe5e9296dcf5a7b02&o=",
    },
    {
        id:9,
        name:"嘉義市",
        amount:"75 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/square250/687789.webp?k=e17d0b828562952dbc0c784eabfdc20b8720e61ed16aa6e8aa65752cbcd439c3&o=",
    },

]
export const Attractions=[
    {
        id:0,
        name:"京都",
        flag:"https://cf.bstatic.com/static/img/flags/24/jp/57eec136ebb3e4b4cdb0a70ada7a285c7379ffa2.png",
        amount:"3,136 間住宿",
        img:"https://hk.wamazing.com/media/wp-content/uploads/sites/5/2019/08/inarijinjya_eyecatch.jpg.webp",
    },
    {
        id:1,
        name:"奈良",
        flag:"https://cf.bstatic.com/static/img/flags/24/jp/57eec136ebb3e4b4cdb0a70ada7a285c7379ffa2.png",
        amount:"147 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/540x270/643935.webp?k=9fadcbd8ef976768810f2fa1359b78960d7a49fcfd7aec1733c5101761e3e93d&o=",
    },
    {
        id:2,
        name:"西屯區",
        flag:"https://cf.bstatic.com/static/img/flags/24/tw/814f389fe6b5d9dd6ee86050534b7643b3c1dbe8.png",
        amount:"210 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/540x270/691781.webp?k=d70fb1ff23124331729a71a09e9a794d8c044f84e640d6c56dafb82fde5597d3&o=",
    },
    {
        id:3,
        name:"仁愛鄉",
        flag:"https://cf.bstatic.com/static/img/flags/24/tw/814f389fe6b5d9dd6ee86050534b7643b3c1dbe8.png",
        amount:"175 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/540x270/691709.webp?k=33fab532ad5a9e8850f4500ecce8ce7d6161a8bfa47b400916e1af2189176587&o=",
    },
    {
        id:4,
        name:"台中",
        flag:"https://cf.bstatic.com/static/img/flags/24/tw/814f389fe6b5d9dd6ee86050534b7643b3c1dbe8.png",
        amount:"560 間住宿",
        img:"https://cf.bstatic.com/xdata/images/city/540x270/687887.webp?k=66079e811213908cc815d1df8ec3f5bb1feff7ef6b055a52aa7f14026cfad5c7&o=",
    }
]

export const PopularHotelsData=[
    {
        id:0,
        name:"帕特奧斯昂托艾斯特瓦",
        place:"里斯本",
        price:8535,
        rate:9.3,
        comment:275,
        img:"https://cf.bstatic.com/xdata/images/hotel/max500/103951224.jpg?k=03736dd4e1e89c1132e4957149e394d01ac6e8f64f4b09e30ade97a6176f0640&o=",
    },
    {
        id:1,
        name:"納沃納菲奧雷公寓",
       place:"斯普利特",
        price:7903,
        rate:9.6,
        comment:463,
        img:"https://cf.bstatic.com/xdata/images/hotel/max500/40890517.jpg?k=cd55de5463af8988f78fd675904a43d02f77570debe9977c4c1fe658030b6d29&o=",
    },
    {
        id:2,
        name:"競技場浪漫公寓",
        place:"羅馬",
        price:5903,
        rate:9.6,
        comment:463,
        img:"https://cf.bstatic.com/xdata/images/hotel/max500/109169996.jpg?k=82bee70e09800d9254479024406baebaf45c1482c6627ef44ee35e1df5110dc5&o=",
    },
    {
        id:3,
        name:"城市公園露台公寓",
        place:"布達佩斯",
        price:3501,
        rate:9.7,
        comment:123,
        img:"https://cf.bstatic.com/xdata/images/hotel/max500/109169996.jpg?k=82bee70e09800d9254479024406baebaf45c1482c6627ef44ee35e1df5110dc5&o=",
    },
    {
        id:4,
        name:"Hyde Park Residence",
        place:"倫敦",
        price:453112,
        rate:9.8,
        comment:6,
        img:"https://cf.bstatic.com/xdata/images/hotel/max500/100210804.jpg?k=b4266521a7d7dd6165b0c37f1d18382eeab462ae18efbe779bcfb48b460c06b6&o=",
    }
]